import CloseSharp from '@mui/icons-material/CloseSharp'
import { forwardRef } from 'react'
import { IconButton, Link } from 'ui'

import { HowWork } from './HowWork'
import style from './ModalHow.module.scss'

type TModalHow = {
  close: () => void
}
// модальное окно для мобильной версии
// eslint-disable-next-line react/display-name
export const ModalHow = forwardRef<HTMLDivElement, TModalHow>(
  ({ close }, ref) => (
    <div ref={ref} className={style.modal}>
      <div className={style.header}>
        <Link href='/' className={style.logoLink}>
          <img src='/images/logo-header.svg' alt='DoorHan logo' />
        </Link>
        <IconButton onClick={close} className={style.iconClose}>
          <CloseSharp />
        </IconButton>
      </div>
      <HowWork className={style.content} />
    </div>
  ),
)
